import { incomingInvoicesDe } from './incoming-invoices-de';
import { incomingInvoicesEn } from './incoming-invoices-en';
import { incomingInvoicesTh } from './incoming-invoices-th';

/**
 * Eingangsrechnungs-Zahlart i18n translations (V-0758 Paket (c), 28.09.2026).
 *
 * Eigener Namensraum statt Eintraege in den grossen `web/src/i18n/locales/*.json` — die tragen
 * gerade grosse fremde, uncommittete Aenderungen anderer Sitzungen. Muster: `web/src/webpos/i18n`
 * bzw. `web/src/components/zahlarten/i18n` (siehe dort fuer die Registrierung in
 * `web/src/i18n/index.ts`).
 */
export const incomingInvoicesTranslations = {
  de: incomingInvoicesDe,
  en: incomingInvoicesEn,
  th: incomingInvoicesTh,
};
